import { cleanUpAndCreateNode } from './utility';
export const transformAction = (action) => ({
    id: action.id,
    keyword: action.keyword,
    $: action.dom,
    command: cleanUpAndCreateNode(action.command),
    enable: action.enable,
});
//# sourceMappingURL=item.js.map